import { BallTriangle } from "react-loader-spinner";

const PreLoader = () => {
  return (
    <BallTriangle
      height={100}
      width={100}
      radius={5}
      color="#16509a"
      ariaLabel="ball-triangle-loading"
      wrapperStyle={{}}
      wrapperClass=""
      visible={true}
    />
  );
};
export default PreLoader;
